class StickyCta extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('data-section-id');
    this.header = document.querySelector('.section-header');
  }

  connectedCallback() {
    if (!this.sectionId) return;

    const container = document.getElementById(`StickyCta-${this.sectionId}`);
    if (!container) return;

    const submitBtn = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
    // Delegate click to handle dynamic re-renders of inner content
    if (submitBtn) {
      container.addEventListener('click', (e) => {
        const stickyBtn = e.target && e.target.closest(`#StickyCtaButton-${this.sectionId}`);
        if (!stickyBtn) return;
        e.preventDefault();
        try {
          submitBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => {
            submitBtn.focus({ preventScroll: true });
          }, 400);
          submitBtn.click();
        } catch (_) {
          window.location.hash = `#ProductSubmitButton-${this.sectionId}`;
        }
      });
    }

    // If the in-content CTA doesn't exist, keep sticky visible
    if (!submitBtn) {
      container.classList.add('sticky');
      return;
    }

    // Observe visibility of the standard CTA
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry) return;

          const rect = submitBtn.getBoundingClientRect();
          const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
          const aboveView = rect.bottom <= 0;
          const belowView = rect.top >= viewportHeight;
          const isVisibleVertically = !aboveView && !belowView;

          if (isVisibleVertically) {
            container.classList.remove('sticky');
          } else {
            container.classList.toggle('sticky', aboveView);
          }
        },
        { root: null, threshold: [0, 1] },
      );
      io.observe(submitBtn);
    } else {
      // Fallback
      const check = () => {
        const rect = submitBtn.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const aboveView = rect.bottom <= 0;
        const belowView = rect.top >= viewportHeight;
        const isVisibleVertically = !aboveView && !belowView;
        container.classList.toggle('sticky', aboveView && !isVisibleVertically);
      };
      check();
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
    }

    // Add watcher on the shopify-section-header-sticky class
    this.observeHeader();
  }

  observeHeader() {
    const checkHeader = () => {
      const container = document.getElementById(`StickyCta-${this.sectionId}`);
      if (!container) return;

      if (window.innerWidth <= 990) {
        container.style.top = '';
        return;
      }

      let offset = 0;
      const headerVisible = this.header && !this.header.classList.contains('shopify-section-header-hidden');
      const headerRect = headerVisible ? this.header.getBoundingClientRect() : null;
      if (headerRect) {
        offset = headerRect.bottom;
      }

      const openMegaContents = document.querySelectorAll('.mega-menu[open] .mega-menu__content');
      openMegaContents.forEach((content) => {
        const rect = content.getBoundingClientRect();
        if (rect && rect.height) {
          offset = Math.max(offset, rect.bottom);
        }
      });

      if (offset > 0) {
        container.style.top = `${offset}px`;
      } else {
        container.style.top = '0px';
      }
    };

    if (!this._headerListenersAttached) {
      window.addEventListener('resize', checkHeader);
      window.addEventListener('scroll', checkHeader, { passive: true });
      this._headerListenersAttached = true;
    }

    if (!this._megaMenuObserver) {
      this._megaMenuObserver = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type !== 'attributes') continue;
          const target = mutation.target instanceof Element ? mutation.target : null;
          if (target && (target.matches('.mega-menu') || target.closest('.mega-menu'))) {
            checkHeader();
            break;
          }
        }
      });
      this._megaMenuObserver.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['open'],
      });
    }

    checkHeader();
  }
}

customElements.define('sticky-cta', StickyCta);
